<template>
  <div class="con_content">
       <div class="container heng_table">
           <div class="container_top h_48">综合统计</div>
            <Header class="my_title txt_l  my_title_bottom">
                <span class="my_titleL">
                    <Icon class="fw_900 " type="ios-list" size='30'/>     
                    综合统计
                </span>
                 <div class="ct_rgt">
                    <div class="sta_btn  sb_e">
                        <Row>
                            
                            <Col span="12">
                                <DatePicker split-panels @on-change='dateFun' v-model="date" type="daterange"  placement="bottom-end" placeholder="请选择时间"  @on-clear='clearFun'  clearable   style="width: 200px"></DatePicker>
                            </Col>
                        </Row>
                                        </div>
                    <div :class="[type == 2?'time_active':''] " class="sta_btn  sb_d"  @click="btnFun(2)">最近30天</div>
                    <div :class="[type == 1?'time_active':''] " class="sta_btn  sb_c"  @click="btnFun(1)">全部</div>
                    <div :class="[type == 0?'time_active':''] " class="sta_btn  sb_b"  @click="btnFun(0)">今天</div>
                    <div class="sta_btn  sb_a" type="primary"   @click="exportData">导出数据</div>
                    
                    
                    
                    
                </div>
            </Header>
          
           <div class="my_table my_title_table">
               <div>
                   <div class="title">
                        <Icon type="md-bookmark" />订单统计
                   </div>

                    <Table   ref='table1'  border  :columns="columns1" :data="data1" ></Table>
                  
               </div>
           </div>  
           <div class="my_table my_title_table">
               <div>
                   <div class="title">
                       <Icon type="md-bookmark" />会员统计
                   </div>
                   <Table  ref='table2'   border  :columns="columns2" :data="data2" ></Table>
                    

               </div>

           </div>
           

       </div>
  </div>
</template>

<script>
  

    export default {
        name:'statistics',
        data () {
            return {
                token:'',
    
             
                date:'',

                // ajax
                type:0,
                time_star:'',
                time_end:'',


                order:Object,
                vip:Object,



                options2: {
                    shortcuts: [
                        {
                            text: '1 week',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                        {
                            text: '1 month',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: '3 months',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        }
                    ]
                },

                columns1:[
                    {
                        title: '名称',
                        key: 'name',
                        width:'350',
                        align:'center'
                    },
                    {
                        title: '数据',
                        key: 'num',
                        align:'center'
                    },
                   
                   
                ],
                data1:[
                   
                    {
                        name:'',
                        num:''
                       
                    },
                  
                    {
                        name:'',
                        num:''
                     
                    },
                  
                    {
                        name:'',
                        num:''
                      
                    }
                ],

                 columns2:[
                    {
                        title: '名称',
                        key: 'name',
                        width: 350,
                        align:'center'
                    },
                    {
                        title: '数据',
                        key: 'num',
                        align:'center'
                    },
                   
                   
                ],
                data2:[
                   
                    {
                        name:'',
                        num:''
                       
                    },
                  
                    {
                        name:'',
                        num:''
                     
                    },
                  
                    {
                        name:'',
                        num:''
                      
                    },
                    {
                        name:'',
                        num:''
                      
                    }
                ]

            }
        },
       
        watch:{
            type(val,old){
                var that = this;
                that.load(val);
            }
        },
        computed: {
          
            
        },
        methods: {
            load(url){
                var that = this;
                 // vuex
                that.token = that.$store.state.token;
               
                var url;
                if(url != 3){
                    url = 'account/service/admin/finance/statistics?type='+that.type
                }else{
                    url = 'account/service/admin/finance/statistics?type=3&beginTime='+that.time_star+'&endTime='+ that.time_end
                }
              
               
                that.$ajax({
                
                    method:'get',
                    url: url,
                    data: {},
                    
                }).then(res => {
                        // console.log(res.data.data)
                        var my_res = res.data.data;
                        var order = my_res['order'];
                        var vip = my_res['vip'];
                       
                        that.order = order;
                        that.vip = vip;

                        that.data1[0].name = '总销售额';
                        that.data1[0].num = '¥'+ (order.sum/100).toFixed(2);
                        that.data1[1].name = '有效订单总数';
                        that.data1[1].num = order.successOrder;
                        that.data1[2].name = '无效订单总数';
                        that.data1[2].num = order.failOrder;


                        that.data2[0].name = '会员总数';
                        that.data2[0].num = vip.count;
                        that.data2[1].name = 'SVIP会员数';
                        that.data2[1].num = vip.sVIPCount;
                        that.data2[2].name = '每会员购物额';
                        that.data2[2].num = '¥'+ (vip.membershipPurchases/100).toFixed(2);
                        that.data2[3].name = '会员购买率';
                        that.data2[3].num = (vip.purchaseRate*100).toFixed(2)+'%';

                      
                  
                }).catch(err=>{
                    console.log(err)
                })

              
           },
        //    选择日期范围
           dateFun(data){
               var that = this;
               that.time_star = data[0];
               that.time_end = data[1];
               if(that.time_star != ''){
                   that.type = 3;
               }

             
           },

            // 选择其他改type
           btnFun(data){
               var that = this;
               that.type = data;
               that.date = '';
           },

            //    导出
            exportData(){
                var that = this;
                that.$refs.table1.exportCsv({
                    filename: '综合统计',
                    original: false
                });
                that.$refs.table2.exportCsv({
                    filename: 'vip',
                    original: false
                });
            },
            //    清除搜索框
            clearFun(){
                var that = this;
                that.type=0;
              
            }
            
           
            
        },
        mounted: function(){
           var that = this;
            that.checkGuid = that.$store.state.checkGuid;
           that.load(0);
            
        }
    }
</script>
<style scoped>
    

    .my_title_bottom{
        border-bottom: 1px solid #e4e4e4;
    }
    .ct_rgt{
        width: auto;
        height: 100%;
        float: right;
    }
    .ct_rgt .sta_btn{
        float: right;
        width: 88px;
        height: 30px;
        line-height: 28px;
        margin-top: 14px;
        text-align: center;
        /* background: #1abc9c; */
        border: 1px solid #ccc;
    }
    .ct_rgt .sb_a{
        margin-right: 10px;
    }
    .ct_rgt .sb_b{
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-right: 0;
    }
    .ct_rgt .sb_d{
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-left: 0;
        margin-right: 10px;
    }
    .ct_rgt .sb_e{
        position: relative;
        
        width: auto;
        background: transparent;
        border: none;
    }
    .ct_rgt .time_active{
        background: #1abc9c;
        border-color:#1abc9c;
        color: white;
    }

    /* 底部列表 */
   .my_table{
       width: 100%;
   }

   .title{
       width: 100%;
       height: 68px;
       line-height: 68px;
       text-align: left;
       font-size: 17px;
   }
  
    .my_title_table{
        padding-bottom: 35px;
    }
   
    
</style>




